import { SearchProject } from '@platform/client/schemas';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { ProjectSearchFilters } from './ProjectSearchForm';
import { Dispatch, useContext, useMemo } from 'react';
import { AdminTable, AdminTableContext } from '../../../AdminTable';
import { ModalCallToAction } from '@platform/components';
import { keepPreviousData } from '@tanstack/react-query';
import { AdminSearch } from '@platform/client';
import { projectFiltersToQueryParams } from '../utils';

const projectColumnHelper = createColumnHelper<SearchProject>();

export const ProjectResultsTable = (props: {
  filters: ProjectSearchFilters;
  setFilters: Dispatch<React.SetStateAction<ProjectSearchFilters | undefined>>;
  setDownloadModalOpen: Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { filters, setDownloadModalOpen } = props;
  const { adminQueryOptionsV2 } = useContext(AdminTableContext);
  const { data, isLoading, isError, isSuccess } = AdminSearch.useAdminSearchProjects(
    {
      ...projectFiltersToQueryParams(filters),
      page: adminQueryOptionsV2.page,
      limit: adminQueryOptionsV2.limit,
    },
    {
      query: {
        placeholderData: keepPreviousData,
      },
    },
  );
  const { projects = [], filteredCount = 0 } = data || {};
  const columns = useMemo(() => {
    return [
      projectColumnHelper.accessor('id', {
        header: 'ID',
        cell: (info) => info.getValue(),
      }),
      projectColumnHelper.accessor('name', {
        header: 'Project Name',
        cell: (info) => info.getValue(),
      }),
      projectColumnHelper.accessor('repFirstname', {
        header: 'Representative',
        cell: ({ row }) => `${row.original.repFirstname} ${row.original.repLastname}`,
      }),
    ] as ColumnDef<SearchProject>[];
  }, []);

  const tableActions: ModalCallToAction[] = [
    {
      text: 'Modify filters',
      callback: () => {
        props.setFilters(undefined);
      },
    },
  ];
  if (isSuccess && projects.length > 0) {
    tableActions.push({
      text: 'Export results',
      callback: () => {
        setDownloadModalOpen(true);
      },
    });
  }

  return (
    <AdminTable
      data={projects}
      filteredCount={filteredCount}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      enableSorting={false}
      tableActions={tableActions}
    />
  );
};
